var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 44.999 32.958 c -6.641 0 -12.042 5.402 -12.042 12.042 c 0 6.641 5.401 12.044 12.042 12.044 S 57.041 51.642 57.041 45 C 57.041 38.358 51.639 32.958 44.999 32.958 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 57.593 19.443 H 32.407 v -0.001 c -7.148 0 -12.962 5.815 -12.962 12.962 V 57.59 c -0.001 7.149 5.814 12.964 12.962 12.964 h 25.186 c 7.148 0 12.964 -5.814 12.964 -12.962 V 32.406 C 70.557 25.257 64.742 19.443 57.593 19.443 z M 44.999 61.488 c -9.092 0 -16.487 -7.396 -16.487 -16.487 c 0 -9.092 7.396 -16.487 16.487 -16.487 s 16.487 7.396 16.487 16.487 C 61.485 54.092 54.089 61.488 44.999 61.488 z M 60.939 31.281 c -1.84 0 -3.332 -1.492 -3.332 -3.332 c 0 -1.84 1.492 -3.332 3.332 -3.332 s 3.332 1.492 3.332 3.332 C 64.271 29.789 62.779 31.281 60.939 31.281 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 v 90 h 90 V 0 H 0 z M 75.001 57.591 c 0 9.598 -7.808 17.406 -17.408 17.406 H 32.407 c -9.598 0 -17.406 -7.808 -17.406 -17.406 V 32.406 c 0 -9.598 7.808 -17.406 17.406 -17.406 h 25.186 c 9.599 0 17.408 7.808 17.408 17.406 V 57.591 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.bfc1a3597d7ed8f7e1fa3c8cb5cc4533.svg";
export { ForwardRef as ReactComponent };